export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dollar_sign.d90ed5d8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};